"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CustomDetails = void 0;
var classnames_1 = __importDefault(require("classnames"));
var lodash_1 = require("lodash");
var react_1 = __importDefault(require("react"));
var AcceptFlowContextProvider_1 = require("@CommonFrontend/AcceptFlow/AcceptFlowContextProvider");
var kaleidoscope_1 = require("@qwilr/kaleidoscope");
var ValidateInjection_1 = require("./ValidateInjection");
var styles = __importStar(require("./CustomDetails.css"));
var CustomDetails = function () {
    var _a, _b;
    var _c = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)(), settings = _c.settings, isPrintMode = _c.isPrintMode, isSimpleMode = _c.isSimpleMode;
    var fields = (_b = (_a = settings.customForm) === null || _a === void 0 ? void 0 : _a.fields) !== null && _b !== void 0 ? _b : [];
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)("custom-details", styles.container({ isPrintMode: isPrintMode, isSimpleMode: isSimpleMode })) }, fields.map(function (field) {
        if (field.type === "dropdown") {
            return react_1.default.createElement(FormDropdown, { field: field, key: field.id });
        }
        return (react_1.default.createElement(kaleidoscope_1.FormTextInput, { name: field.id, label: field.name, key: field.id, validate: function (value) {
                if (field.isRequired && !value) {
                    return "This field cannot be empty";
                }
                return (0, ValidateInjection_1.validateInjection)(value, { allowUrlsOrEmails: true });
            } }));
    })));
};
exports.CustomDetails = CustomDetails;
var FormDropdown = function (_a) {
    var field = _a.field;
    var isPrintMode = (0, AcceptFlowContextProvider_1.useAcceptFlowContext)().isPrintMode;
    if (isPrintMode) {
        return (react_1.default.createElement("div", { className: "custom-details-select" },
            react_1.default.createElement(kaleidoscope_1.Label, { long: true, size: "s", element: "label" }, field.name),
            react_1.default.createElement("div", null, field.items.map(function (item) { return (react_1.default.createElement(kaleidoscope_1.Checkbox, { id: item, label: item, checked: false, onChange: lodash_1.noop, size: "s", key: item, className: "custom-details-select__checkbox" })); }))));
    }
    return (react_1.default.createElement(kaleidoscope_1.Layer, null, function () { return (react_1.default.createElement(kaleidoscope_1.FormSelect, { "data-is-required": field.isRequired, name: field.id, label: field.name, key: field.id, initialValue: "", validate: function (value) {
            if (field.isRequired && !value) {
                return "Please select an option";
            }
        }, className: styles.formSelect, autoStack: true }, field.items.map(function (item) {
        return (react_1.default.createElement(kaleidoscope_1.SelectOption, { value: item, key: item }, item));
    }))); }));
};
